<template>
  <el-row :gutter="20">
    <el-col :span="16">
      <Options :data="items" @select="select" @remove="remove" />
    </el-col>
    <el-col :span="8">
      <SelectedOptions :data="items" @remove="remove" @clear="clear" />
    </el-col>
  </el-row>
</template>

<script>
import lodash from 'lodash'
import Options from '../selector-options'
import SelectedOptions from '../selector-selected-options'
export default {
  components: { Options, SelectedOptions },
  props: { data: { type: Array, default: () => [] } },
  data() {
    return { items: [] }
  },
  mounted() {
    this.items = this.data
  },
  methods: {
    select(row) {
      if (!row) return

      if (lodash.some(this.items, { userCode: row.userCode })) return

      this.items.push(row)
    },
    remove(row) {
      if (!row) return

      const index = lodash.findIndex(this.items, { userCode: row.userCode })
      if (index === -1) return

      this.items.splice(index, 1)
    },
    clear() {
      this.items = []
    },
    getData() {
      return this.items
    },
  },
}
</script>

<style lang="scss" scoped></style>
